import { z } from 'zod'

export const CompanySchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  externalId: z.uuid(),
  slug: z.string(),
  access: z.enum(['COMPANY_WIDE', 'SITE_LIMITED'])
})

export const SiteSchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  externalId: z.uuid(),
  location: z.string().nullish()
})

export const CompaniesSchema = z.array(CompanySchema)
export const SitesResponseSchema = z.array(SiteSchema)

export type Site = z.infer<typeof SiteSchema>
export type Company = z.infer<typeof CompanySchema>
export type Companies = z.infer<typeof CompaniesSchema>
